import type { WalletPermissionsEffective } from '@/data/marketApi/types'

let currentPermissions: WalletPermissionsEffective = {
  address: '',
  expertModeEnabled: false,
  internalRoutesEnabled: false,
}

export function syncWalletPermissionsFromApi(permissions: WalletPermissionsEffective): void {
  currentPermissions = {
    address: permissions.address.toLowerCase(),
    expertModeEnabled: permissions.expertModeEnabled,
    internalRoutesEnabled: permissions.internalRoutesEnabled,
  }
}

export function getWalletPermissionsForAccount(
  account: string | null | undefined,
): WalletPermissionsEffective | null {
  if (!account) return null
  if (currentPermissions.address !== account.toLowerCase()) return null
  return currentPermissions
}

export function hasExpertModeAccess(account: string | null | undefined): boolean {
  const permissions = getWalletPermissionsForAccount(account)
  return permissions?.expertModeEnabled === true
}

export function hasInternalRoutesAccess(account: string | null | undefined): boolean {
  const permissions = getWalletPermissionsForAccount(account)
  return permissions?.internalRoutesEnabled === true
}

/** Solo tests. */
export function __resetWalletPermissionsRegistryForTests(): void {
  currentPermissions = {
    address: '',
    expertModeEnabled: false,
    internalRoutesEnabled: false,
  }
}
